<template>
  <span
    v-text="fullText"
    :class="dateClasses"
  />
</template>

<script setup>
import useDateFormatting from '@/shared/composables/useDateFormatting';

const $bct = inject('translator');

const { formatDate } = useDateFormatting();

const props = defineProps({
  date: {
    type: String,
    default: null,
  },
  dateClasses: {
    type: String,
    default: null,
  },
  hideDay: {
    type: Boolean,
    default: false,
  },
  hideYear: Boolean,
  noTranslateSuffix: {
    type: Boolean,
    default: false,
  },
  nulltext: {
    type: String,
    default: '',
  },
  prefix: {
    type: String,
    default: '',
  },
  suffix: {
    type: String,
    default: '',
  },
  shortMonth: {
    boolean: false,
    type: Boolean,
  },
});

const fullText = computed(() => {
  if (localeDateString.value) {
    const str = [];
    if (props.prefix) {
      str.push($bct(props.prefix));
    }

    str.push(localeDateString.value);

    if (props.suffix) {
      str.push(props.noTranslateSuffix ? props.suffix : $bct(props.suffix));
    }

    return str.join(' ');
  }
  return $bct(props.nulltext);
});

const localeDateString = computed(() => {
  if (!props.date) return '';

  return formatDate(props.date, {
    shortMonth: props.shortMonth,
    hideDay: props.hideDay,
    hideYear: props.hideYear,
  });
});
</script>
